import { Card, Image, Spin } from "antd";
import '../../global.scss';
import { Link } from "react-router-dom";
import { useEffect } from 'react';
import series from '../../data/series.json';

const imgSrc = path => path.split('/').map(encodeURIComponent).join('/');
const allMainImages = series.flatMap(s => s.works.map(w => imgSrc(w.main)));

function Works() {
    useEffect(() => {
        allMainImages.forEach(src => {
            const link = document.createElement('link');
            link.rel = 'preload';
            link.as = 'image';
            link.href = src;
            document.head.appendChild(link);
        });
    }, []);

    return (
        <div className="works-page">
            {series.map((s) => (
                <div key={s.id} className="series-section">
                    <div className="series-header">
                        <span className="series-eyebrow">Series</span>
                        <h2 className="series-name">{s.name}</h2>
                    </div>
                    <div className="works-grid">
                        {s.works.map((work) => (
                            <Link key={work.id} to={`/works/${work.id}`} className="work-card">
                                <Card
                                    bordered={false}
                                    cover={
                                        <Image
                                            height={360}
                                            alt={work.title}
                                            src={imgSrc(work.main)}
                                            preview={false}
                                            placeholder={
                                                <Spin style={{
                                                    position: 'absolute',
                                                    top: '50%',
                                                    left: '50%',
                                                    transform: 'translate(-50%, -50%)',
                                                    zIndex: 1,
                                                }} />
                                            }
                                        />
                                    }
                                >
                                    <div className="work-card-info">
                                        <span className="work-card-title">{work.title}</span>
                                        <span className="work-card-desc">{work.medium} · {work.dimensions}</span>
                                    </div>
                                </Card>
                            </Link>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );
}

export default Works;
